import { type MediaAttributes } from "@exonn/js-sdk";
export enum ProductRowType {
  Set = "set",
  SetComponent = "set_component",
  Single = "single",
  Multiple = "multiple",
  Complex = "complex",
  MultipleVariant = "multiple_variant",
  ComplexVariant = "complex_variant",
  ComplexSetVariant = "complex_set_variant",
  ComplexSetVariantComponent = "complex_set_component_variant",
}
export interface ProductRowResource {
  id: string;
  type: ProductRowType;
  descendants_count: number;
  images: { [uuid: string]: MediaAttributes };
  price: string;
  sku: string;
  short_description: string;
  path: string[];
  status: "active" | "inactive" | "blocked";
  title: string;
  weight: string;
  unit_quantity: string;
}
